import React from 'react'
import _ from 'underscore'
import { Check, X } from 'lucide-react'

const CheckIcon = (props) => <Check className="mr-2 inline size-3.5 text-[#3ecf8e]" {...props}/>
const XIcon = (props) => <X className="mr-2 inline size-3.5 text-destructive" {...props}/>

class TutorResultTutorBiography extends React.Component {

  renderDescriptors = () => {
    if (this.props.tutor_result.tutor.has_transport && this.props.tutor_result.tutor.good_match_guarantee)
      return (
        <React.Fragment>
          <div>
            <label className="font-semibold"><CheckIcon title="Has Transport"/>Has Transport</label>
          </div>
          <div>
            <label className="font-semibold"><CheckIcon title="Has Good Match Guarantee"/>Good Match Guarantee</label>
          </div>
        </React.Fragment>
      )
    else if (this.props.tutor_result.tutor.has_transport && !this.props.tutor_result.tutor.good_match_guarantee)
      return (
        <React.Fragment>
          <div>
            <label className="font-semibold"><CheckIcon title="Has Transport"/>Has Transport</label>
          </div>
          <div>
            <label className="font-semibold"><XIcon title="Does NOT have Good Match Guarantee"/>Good Match Guarantee</label>
          </div>
        </React.Fragment>
      )
    else if (this.props.tutor_result.tutor.good_match_guarantee && !this.props.tutor_result.tutor.has_transport)
      return (
        <React.Fragment>
          <div>
            <label className="font-semibold"><CheckIcon title="Has Good Match Guarantee"/>Good Match Guarantee</label>
          </div>
          <div>
            <label className="font-semibold"><XIcon title="Does NOT have Transport"/>Has Transport</label>
          </div>
        </React.Fragment>
      )
    else if (!this.props.tutor_result.tutor.has_transport && !this.props.tutor_result.tutor.good_match_guarantee)
      return (
        <React.Fragment>
          <div>
            <label className="font-semibold"><XIcon title="Does NOT have Transport"/>Has Transport</label>
          </div>
          <div>
            <label className="font-semibold"><XIcon title="Does NOT have Good Match Guarantee"/>Good Match Guarantee</label>
          </div>
        </React.Fragment>
      )

    return null
  }

  render() {
    const requiredTags = [
      'University Transcript',
      'Identity Document',
      'Matric Certificate',
      'Tutoring Clearance',
      'Reference Letter',
      'Other Supporting Documents'
    ]

    const currentTags = _.map(this.props.tutor_result.documents, function(document) {return document.tag })
    const missingTags = _.difference(requiredTags, currentTags)

    return (
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-4">
        <div className="grid content-start gap-3 lg:col-span-3">
          <div><label className="mr-2 inline-block font-semibold">About Me:</label>{this.props.tutor_result.biography.about_me}</div>
          <div><label className="mr-2 inline-block font-semibold">Achievements:</label>{this.props.tutor_result.biography.achievements}</div>
          <div><label className="mr-2 inline-block font-semibold">High School:</label>{this.props.tutor_result.biography.highschool}</div>
          <div><label className="mr-2 inline-block font-semibold">Tertiary Education:</label>{this.props.tutor_result.biography.tertiary_education}</div>
          <div><label className="mr-2 inline-block font-semibold">Tutoring Justification:</label>{this.props.tutor_result.biography.tutoring_justification}</div>
          <div><label className="mr-2 inline-block font-semibold">Citizenship:</label><span className="uppercase">{this.props.tutor_result.tutor.citizenship}</span></div>
        </div>
        <div className="grid content-start gap-3">
          {_.map(this.props.tutor_result.documents, function(document) {
            return _.map(currentTags, function(currentTag) {
              if (currentTag === document.tag) {
                return (
                  <div key={document.tag}>
                    <label className="font-semibold"><CheckIcon title={`Has ${document.tag}`}/><a href={document.url} target="_blank">{document.tag}</a></label>
                  </div>
                )
              }
              else {
                return null
              }
            })
          })}
          {this.renderDescriptors()}
          {_.map(missingTags, (missingTag) => {
            return (
              <div key={missingTag}>
                <label className="font-semibold"><XIcon title={`Does NOT have ${missingTag}`}/>{missingTag}</label>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

export default TutorResultTutorBiography
